// Category → simple sub-category list (no images, no descriptions, no enquiry buttons).
// Displayed as a two-column icon list under "Product Categories" heading.

export const SUBCATEGORIES = {
  "dye-penetrant-testing": [
    { label: "Cleaner / Remover", icon: "Droplets" },
    { label: "Red Visible Penetrants", icon: "FlaskConical" },
    { label: "Fluorescent Penetrants", icon: "Sparkles" },
    { label: "Developers", icon: "PaintbrushVertical" },
    { label: "Water-Washable Penetrant Products", icon: "Droplet" },
    { label: "Solvent-Removable Penetrant Products", icon: "Container" },
  ],
  "magnetic-particle-inspection": [
    { label: "Magnetic Inks", icon: "Magnet" },
    { label: "Magnetic Powders", icon: "Grid3x3" },
    { label: "Contrast Paint", icon: "Palette" },
    { label: "Fluorescent Magnetic Particles", icon: "Zap" },
    { label: "White Background Paint", icon: "SquareDashed" },
    { label: "MPI Consumables", icon: "Package" },
  ],
  "ndt-equipment-accessories": [
    { label: "UV Lamps", icon: "Lightbulb" },
    { label: "Yoke Machines", icon: "Wrench" },
    { label: "Lux Meters", icon: "Gauge" },
    { label: "UV Intensity Meters", icon: "Activity" },
    { label: "Field Indicators", icon: "Compass" },
    { label: "Inspection Accessories", icon: "Cog" },
  ],
  "test-reference-blocks": [
    { label: "Reference Test Blocks", icon: "LayoutGrid" },
    { label: "Comparator Blocks", icon: "Layers" },
    { label: "Penetrant Testing Panels", icon: "Grid" },
    { label: "Magnetic Particle Test Blocks", icon: "Grid2x2" },
    { label: "Customized Test Blocks", icon: "Settings2" },
  ],
  "klyde-zinc-materials": [
    { label: "Zinc Spray", icon: "SprayCan" },
    { label: "Cold Galvanizing Spray", icon: "Shield" },
    { label: "Zinc-Rich Primer", icon: "PaintBucket" },
    { label: "Zinc Paint", icon: "Brush" },
    { label: "Zinc Metal Coating", icon: "Layers2" },
    { label: "Industrial Protective Coatings", icon: "ShieldCheck" },
  ],
};

export const CATEGORY_BROCHURE = {
  "dye-penetrant-testing": { label: "Dye Penetrant Testing Brochure" },
  "magnetic-particle-inspection": { label: "Magnetic Particle Inspection Brochure" },
  "ndt-equipment-accessories": { label: "NDT Equipment Brochure — SMART CHOICE" },
  "test-reference-blocks": { label: "Test Blocks Reference" },
  "klyde-zinc-materials": { label: "KLYDE Zinc Catalogue — ZINCKED" },
};
